export default __webpack_public_path__ + "static/media/challenge-power.9a835b04.svg";